import Button from 'components/Button';
import SectionText from 'components/SectionText';
import styled from 'styled-components';
import { device } from './breakpoints';

export const SectionTextWrapper = styled(SectionText)`
  margin-bottom: 2.5rem;
`;

export const ActionButton = styled(Button)`
  margin: 3.5rem 0 0 !important;
`;

export const WebMobileView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media ${device.lg} {
    width: 100dvw;
    height: 100dvh;
    margin: 0;
  }
`;
